export const navItems = [
	{
		id: 1,
		title: "About",
		path: "/about",
		cName: "navbar-menulist",
	},
	{
		id: 2,
		title: "Contact",
		path: "/contact",
		cName: "navbar-menulist",
	},
	{
		id: 3,
		title: "Blog",
		path: "/blog",
		cName: "navbar-menulist",
	},
	{
		id: 4,
		title: "Help",
		path: "/help",
		cName: "navbar-menulist",
	},
	{
		id: 5,
		title: "Account",
		path: "/UsersSignIn",
		cName: "navbar-menulist",
	},
	{
		navName: "landing-nav-btn nav-close-btn",
	},
];

export const accountDropdown = [
	{
		id: 1,
		title: "Buyer",
		path: "/buyersignup",
		cName: "account-submenu",
	},
	{
		id: 2,
		title: "Farmer",
		path: "/farmersignup",
		cName: "account-submenu",
	},
	{
		id: 3,
		title: "Broker",
		path: "/brokersignup",
		cName: "account-submenu",
	},
];
